<template>
  <section class="invoice-create-page">
    <div class="invoice-create-top-grid invoice-detail-top-grid">
      <InvoiceDetailOperationCard
        :operation="invoiceOperation"
        :comments="comments"
        :subtotal="subtotal"
        :transferred-tax-amount="transferredTaxAmount"
        :withheld-tax-amount="withheldTaxAmount"
        :total="total"
        :currency="currency"
        @pay-action="$emit('pay-invoice')"
      />

      <InvoiceDetailFiscalSummaryCard
        :issuer="issuer"
        :selected-receiver="selectedReceiver"
        :invoice-info="invoiceInfo"
        :payment-method-label="paymentMethodLabel"
        :payment-form-label="paymentFormLabel"
      />
    </div>

    <InvoiceCreateConceptsCard
      :concepts="concepts"
      :currency="currency"
      :read-only="true"
      :concept-link-resolver="resolveConceptSaleRoute"
      :concept-link-title="conceptSaleLinkTitle"
      concept-link-class="invoice-create-concept-description-link--detail"
    />

    <InvoiceCreateBottomSection
      :comments="comments"
      :discount-rate="0"
      :subtotal="subtotal"
      :discount-amount="discountAmount"
      :transferred-tax-amount="transferredTaxAmount"
      :withheld-tax-amount="withheldTaxAmount"
      :total="total"
      :currency="currency"
      :read-only="true"
      :hide-comments="true"
      :empty-read-only-comments-placeholder="''"
    >
      <template #left-card>
        <RecentActivityCard
          :entity-id="invoiceId"
          entity-type="invoice"
          :per-page="4"
          :show-footer="false"
        />
      </template>
    </InvoiceCreateBottomSection>
  </section>
</template>

<script>
import InvoiceCreateConceptsCard from '@/components/invoices/create/InvoiceCreateConceptsCard.vue';
import InvoiceCreateBottomSection from '@/components/invoices/create/InvoiceCreateBottomSection.vue';
import InvoiceDetailFiscalSummaryCard from '@/components/invoices/detail/tabs/InvoiceDetailFiscalSummaryCard.vue';
import InvoiceDetailOperationCard from '@/components/invoices/detail/InvoiceDetailOperationCard.vue';
import RecentActivityCard from '@/components/common/RecentActivityCard.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: invoiceText } = useDomainText('invoices');

export default {
  name: 'InvoiceDetailTabDetail',
  emits: ['pay-invoice'],
  components: {
    InvoiceCreateConceptsCard,
    InvoiceCreateBottomSection,
    InvoiceDetailFiscalSummaryCard,
    InvoiceDetailOperationCard,
    RecentActivityCard,
  },
  props: {
    invoice: {
      type: Object,
      default: null,
    },
    issuer: {
      type: Object,
      default: () => ({}),
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
    invoiceInfo: {
      type: Object,
      default: () => ({}),
    },
    paymentMethodLabel: {
      type: String,
      default: '',
    },
    paymentFormLabel: {
      type: String,
      default: '',
    },
    concepts: {
      type: Array,
      default: () => [],
    },
    comments: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    discountAmount: {
      type: Number,
      default: 0,
    },
    transferredTaxAmount: {
      type: Number,
      default: 0,
    },
    withheldTaxAmount: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    invoiceOperation: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      text: invoiceText,
    };
  },
  computed: {
    invoiceId() {
      return Number(this.invoice?.id || 0) || 0;
    },
    conceptSaleLinkTitle() {
      return String(this.text?.table?.links?.saleDetail || 'Ir al detalle del negocio').trim() || 'Ir al detalle del negocio';
    },
  },
  methods: {
    resolveConceptSaleRoute(concept) {
      const invoiceType = String(this.invoice?.invoice_type || this.invoice?.type || '').trim().toLowerCase();
      if (invoiceType === 'generic') {
        return null;
      }

      const saleId = Number(concept?.saleId || concept?.sale_id || 0) || 0;
      if (saleId <= 0) {
        return null;
      }

      return {
        name: 'saleDetail',
        params: { saleId: String(saleId) },
      };
    },
  },
};
</script>

<style scoped>
.invoice-detail-top-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

@media (max-width: 1100px) {
  .invoice-detail-top-grid {
    grid-template-columns: 1fr;
  }
}
</style>
